import { Grid, Typography, useTheme, Box, Paper, Button, Link } from '@mui/material';
import { useState, useEffect } from 'react';
import EmployeeLogin from './Components/EmployeeLogin';
import CustomerLogin from './Components/CustomerLogin';
import LearnMoreModal from './Components/LearnMoreModal';
import AgeVerificationModal from './Components/AgeVerificationModal';
import Logo from '../../Assets/BugLogo.png';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

const Landing = () => {
  const currentYear = new Date().getFullYear();
  const yearDifference = currentYear - 1841;
  const theme = useTheme();
  const [openModal, setOpenModal] = useState(false);
  const [ageModalOpen, setAgeModalOpen] = useState(false);
  const navigate = useNavigate();

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  useEffect(() => {
    const isVerified = Cookies.get('age-verified');
    if (!isVerified) {
      setAgeModalOpen(true);
    }
  }, []);

  const handleAgeConfirm = (remember) => {
    if (remember) {
      Cookies.set('age-verified', 'true', { expires: 30 });
    }
    setAgeModalOpen(false);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Grid container spacing={2} sx={{ p: 3, maxWidth: '1600px' }}>
        {/* Logo Section */}
        <Grid
          item
          xs={12}
          container
          justifyContent='center'
          alignContent='center'
          sx={{ mt: 2, mb: 3 }}
        >
          <img src={Logo} alt='Logo' style={{ maxWidth: '300px', height: 'auto' }} />
        </Grid>

        {/* History Section */}
        <Grid
          item
          direction='column'
          xs={12}
          container
          justifyContent='center'
          alignContent='center'
          sx={{ flexGrow: 1, mb: 3 }}
        >
          <Typography
            variant='h3'
            sx={{
              color: theme.palette.primary.main,
              textAlign: 'center',
              textTransform: 'uppercase',
              letterSpacing: 8,
              p: 1,
            }}
          >
            Over <span style={{ fontWeight: 'bold' }}>{yearDifference} Years</span> of{' '}
            <span style={{ fontWeight: 'bold' }}>History</span>
          </Typography>
          <Typography variant='h5' sx={{ color: 'gray', textAlign: 'center', fontStyle: 'italic' }}>
            The Story of Our Family-Owned Business Spanning{' '}
            <span style={{ fontWeight: 'bold' }}>THREE</span> Centuries{' '}
            <Link
              component='button'
              variant='h5'
              onClick={handleOpenModal}
              sx={{
                fontStyle: 'italic',
                verticalAlign: 'baseline',
                cursor: 'pointer',
                textUnderlineOffset: '4px',
              }}
            >
              (Learn More)
            </Link>
          </Typography>
        </Grid>

        {/* Values Section */}
        <Grid item xs={12} justifyContent='center' alignContent='center' sx={{ mb: 3 }}>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexWrap: 'wrap',
              gap: 2,
              justifyContent: 'space-around',
            }}
          >
            <Typography
              variant='h4'
              sx={{ color: theme.palette.secondary.main, textTransform: 'uppercase' }}
            >
              Integrity.
            </Typography>
            <Typography
              variant='h4'
              sx={{ color: theme.palette.secondary.main, textTransform: 'uppercase' }}
            >
              Family.
            </Typography>
            <Typography
              variant='h4'
              sx={{ color: theme.palette.secondary.main, textTransform: 'uppercase' }}
            >
              Tradition.
            </Typography>
            <Typography
              variant='h4'
              sx={{ color: theme.palette.secondary.main, textTransform: 'uppercase' }}
            >
              Drive.
            </Typography>
          </Box>
        </Grid>

        {/* Customer Login Section */}
        <Grid item xs={12} md={6}>
          <Paper sx={{ height: '100%' }}>
            <CustomerLogin />
          </Paper>
        </Grid>

        {/* Employee Login Section */}
        <Grid item xs={12} md={6}>
          <Paper sx={{ height: '100%' }}>
            <EmployeeLogin />
          </Paper>
        </Grid>

        {/* Links Section */}
        <Grid item xs={4} sx={{ mt: 4, mb: 3, display: 'flex', justifyContent: 'center' }}>
          <Button
            variant='contained'
            onClick={() => {
              navigate('/contact-us');
              window.scrollTo(0, 0);
            }}
            sx={{ width: { xs: '100%', md: '75%', lg: '50%' } }}
          >
            <Typography variant='h6'>Contact Us</Typography>
          </Button>
        </Grid>
        <Grid item xs={4} sx={{ mt: 4, mb: 3, display: 'flex', justifyContent: 'center' }}>
          <Button
            variant='contained'
            onClick={() => {
              navigate('/opt-in');
              window.scrollTo(0, 0);
            }}
            sx={{ width: { xs: '100%', md: '75%', lg: '50%' } }}
          >
            <Typography href='/opt-in' variant='h6'>
              Opt In
            </Typography>
          </Button>
        </Grid>
        <Grid item xs={4} sx={{ mt: 4, mb: 3, display: 'flex', justifyContent: 'center' }}>
          <Button
            variant='contained'
            onClick={() => {
              navigate('/privacy-policy');
              window.scrollTo(0, 0);
            }}
            sx={{ width: { xs: '100%', md: '75%', lg: '50%' } }}
          >
            <Typography href='/privacy-policy' variant='h6'>
              Privacy Policy
            </Typography>
          </Button>
        </Grid>
      </Grid>

      {/* Learn More Modal Component */}
      <LearnMoreModal open={openModal} onClose={handleCloseModal} />

      {/* Age Verification Modal Component */}
      <AgeVerificationModal open={ageModalOpen} onConfirm={handleAgeConfirm} />
    </Box>
  );
};

export default Landing;
